import { RETAILER_ORDERS_OPEN } from '../constants/retailerOrders';

const initialState = {
  orderModal: false,
};

const retailerOrders = (state = initialState, action) => {
  switch (action.type) {
    case RETAILER_ORDERS_OPEN:
      return {
        ...state,
        orderModal: action.payload,
      };
    default:
      break;
  }

  return state;
};

export default retailerOrders;
